export default __webpack_public_path__ + "imgs/service-img-sp.png";